/* eslint-disable no-loop-func */
import { captureException } from "../constant/sentryConfiguration";
import { v4 } from "uuid";

import { getItineraryPriceAPI } from "../api/itinerary/getItineraryPrice";
import {
  ENVIRONMENT_TYPE,
  LLM_RESPONSE_ERROR,
  jsonPatternRegex,
  replaceNewlineWithSpaceRegex,
} from "../constant/common";
import { environment } from "../constant/environment";
import { iChatData, iCityDetailsResult } from "../types";
import { getSelectedOptionsStringArray } from "./recentlyViewTripsItem";

export function getSelectedOptionsStringArrayFromAllOptions(options: any) {
  if (!options) return "No data";
  let stringArr: any = [];
  for (let i = 0; i < options.length; i++) {
    const ele = options[i]?.tag;
    const selectedOption = getSelectedOptionsStringArray(ele);
    if (selectedOption !== "") stringArr.push(selectedOption);
  }
  let string = stringArr.join(", ");
  return string;
}

export function checkAndReturnSingularOrPluralWord(number: number, word: string) {
  if (!number) return word;
  else if (number === 1) return number + " " + word;
  else return number + " " + word + "s";
}

// Helper function to join options of string
export function concatenateOptionsToString(array: any) {
  let temp = "";
  const tempArray = array.tag;
  for (let i = 0; i < tempArray.length; i++) {
    if (tempArray[i].check) {
      temp += tempArray[i].data + ", ";
    }
  }
  return temp.substring(0, temp.length - 2);
}

export function extractPlanTripPrompt(
  promptTemplate: string,
  city: string,
  climate: any,
  population: any,
  experiences: any,
  budget: any,
  noOfDays: number | string,
  accomodations: any,
  foodPreferences: any,
  selectedDestFlag: boolean
) {
  let climatePopulationPrompt = "";
  let accomodationsPrompt = "";
  let foodPreferencesPrompt = "";

  if (climate !== "")
    climatePopulationPrompt = ` The itinerary should include places with ${climate} in ${population} areas.`;
  if (selectedDestFlag) climatePopulationPrompt = "";
  if (accomodations !== "") accomodationsPrompt = `They would like to stay at (lodging) ${accomodations}.`;
  if (foodPreferences !== "") foodPreferencesPrompt = `They prefer ${foodPreferences} food.`;

  const replacements = {
    noOfDays,
    city,
    climatePopulationPrompt,
    accomodationsPrompt,
    foodPreferencesPrompt,
    budget,
    experiences,
  };
  const prompt = replaceWords(promptTemplate, replacements);
  return prompt;
}

function replaceWords(prompt: string, replacements: any) {
  const pattern = /<([^>]+)>/g;
  prompt = prompt.replace(pattern, (match, group) => {
    const replacement = replacements[group];
    return replacement ? replacement : "";
  });
  return prompt;
}

/**
 * check if there are cities or destination list
 */
export function checkIfThereIsDestination(response: any) {
  try {
    // return LLM_RESPONSE_ERROR.jsonError.error
    const element = [
      {
        start: "<recommendationsJsonStart>",
        end: "<recommendationsJsonEnd>",
        singleTrip: false,
      },
      {
        start: "<itineraryJsonStart>",
        end: "<itineraryJsonEnd>",
        singleTrip: true,
      },
    ];
    let results: any = {};

    let startIndex = 0;
    let endIndex = 0;

    for (let i = 0; i < element.length; i++) {
      const ele = element[i];
      if (response?.data?.result.indexOf(ele.start) > 0) {
        startIndex = response?.data?.result.indexOf(ele.start) + ele.start.length;
        endIndex = response?.data?.result.indexOf(ele.end);
        if (ele.singleTrip) {
          if (startIndex > 0 && endIndex > 0) {
            let subString = response?.data?.result.substring(startIndex, endIndex);
            results = JSON.parse(subString);
          }
          if (JSON.stringify(results) !== "{}") {
            response = {
              ...response,
              data: {
                ...response?.data,
                ...results,
                result: "",
                results: results,
                from: results?.from,
                // numberOfdays: results?.number_of_days,
                numberOfdays:
                  results?.city_wise_itinerary?.reduce(
                    (acc: number, ele: any) => ele?.city_itinerary?.length + acc,
                    0
                  ) || null,
                preText: response?.data?.result.substring(0, startIndex - ele.start.length),
                postText: response?.data?.result.substring(endIndex + ele.end.length, response?.data?.result.length),
                singleCity: true,
                itinerary_version: results?.itinerary_version || 1,
                // cities: [],
                cities: results?.city_wise_itinerary?.map((ele: any) => ({
                  ...ele,
                  cityName: ele?.city_name + ", " + ele?.city_country,
                  // destination_city: ele?.destination_city,
                  // destination_country: ele?.destination_country,
                  // destination_name: ele?.destination_name,
                  // city_name: ele?.city_name,
                  // city_country: ele?.city_country,
                  // city_country_code: ele?.city_country_code,
                  averagePackagePriceForExperiencing: results[0]?.approximate_trip_cost,
                  description: ele?.city_itinerary_description,
                  city_itinerary: [],
                  tripDetails: ele?.city_itinerary?.map((subEle: any) => ({
                    ...subEle,
                    itinerary_by_time_of_the_day: combineDescriptionsByTime(subEle?.itinerary_by_time_of_the_day),
                    itinerary_by_time_of_the_day_data: subEle?.itinerary_by_time_of_the_day.map((subEle_2: any) => ({
                      ...subEle_2,
                      id: v4(),
                    })),
                  })),
                  complete_itinerary_flights_cost: {
                    value: results?.complete_itinerary_flights_cost || "",
                    checkedFlag: true,
                    id: v4(),
                  },
                  complete_itinerary_hotels_cost: {
                    value: results?.complete_itinerary_hotels_cost || "",
                    checkedFlag: true,
                    id: v4(),
                  },
                })),
              },
            };
          }
        } else {
          if (startIndex > 0 && endIndex > 0) {
            let subString = response?.data?.result.substring(startIndex, endIndex);
            results = JSON.parse(subString);
          }
          if (JSON.stringify(results) !== "{}") {
            response = {
              ...response,
              data: {
                ...response?.data,
                result: "",
                preText: response?.data?.result.substring(0, startIndex - ele.start.length),
                postText: response?.data?.result.substring(endIndex + ele.end.length, response?.data?.result.length),
                from: results?.from,
                numberOfdays: results?.number_of_days,
                cities: results?.results?.map((ele: any) => ({
                  // cityName: ele.destination_name,
                  ...ele,
                  // destination_name: ele?.destination_name || "",
                  // destination_city: ele?.destination_city || "",
                  averagePackagePriceForExperiencing: ele.approximate_trip_cost,
                  description: ele.destination_description,
                  destination_country: ele?.destination_country || "",
                })),
                singleCity: false,
              },
            };
          }
        }
      }
    }

    // Check if there is JSON object wihtin the result/pretext/postText
    const normalizedResult = response?.data?.result.replace(replaceNewlineWithSpaceRegex, " ");
    if (jsonPatternRegex.test(normalizedResult)) return LLM_RESPONSE_ERROR.jsonError.error;
    if (response?.data?.postText) {
      const normalizedPostText = response?.data?.postText.replace(replaceNewlineWithSpaceRegex, " ");
      if (jsonPatternRegex.test(normalizedPostText)) return LLM_RESPONSE_ERROR.jsonError.error;
    }
    if (response?.data?.preText) {
      const normalizedPreText = response?.data?.preText.replace(replaceNewlineWithSpaceRegex, " ");
      if (jsonPatternRegex.test(normalizedPreText)) return LLM_RESPONSE_ERROR.jsonError.error;
    }
    if (environment !== ENVIRONMENT_TYPE.PRODUCTION)
      // If no JSON object wihtin the result/pretext/postText return the result
      return response;
  } catch (e) {
    captureException({
      e,
      result: response?.data?.result,
    });
    return LLM_RESPONSE_ERROR.jsonError.error;
  }
}

export function combineDescriptionsByTime(itinerary: any) {
  const result = [];

  // Create a map to hold combined descriptions by time_of_the_day
  const combined: any = {};
  itinerary?.forEach((item: any) => {
    const { time_of_the_day, description } = item;

    // If time_of_the_day already exists in the map, combine the descriptions
    if (combined[time_of_the_day]) {
      combined[time_of_the_day].description += `\n\n${description}`;
    } else {
      // If it doesn't exist, create a new entry in the map with a unique id
      combined[time_of_the_day] = {
        id: v4(), // Generate a unique ID
        ...item,
      };
    }
  });

  // Convert the combined map back to an array format
  for (const key in combined) {
    result.push(combined[key]);
  }

  return result;
}

export function scrollToBottom(scrollContainerRef?: any) {
  const applyMobileScroll = () => {
    const targetY = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    document.body.scrollTo({ top: targetY, behavior: "smooth" });
    // Keyboard up (useSoftKeyboardClass): on iOS the window/root scroll is the
    // visual-viewport pan, so these shoved the visible area down into the space
    // behind the keyboard on every input tap (page/header jerk). `body` is the
    // real scroller on mobile.
    if (document.documentElement.classList.contains("zv-keyboard-open")) return;
    document.documentElement.scrollTo({ top: targetY, behavior: "smooth" });
    window.scrollTo({ top: targetY, behavior: "smooth" });
  };
  setTimeout(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    } else {
      applyMobileScroll();
      setTimeout(applyMobileScroll, 80);
      setTimeout(applyMobileScroll, 240);
    }
  }, 10);
}

export function scrollToBottomCalender(scrollContainerRef?: any, calendarRef?: any) {
  setTimeout(() => {
    if (scrollContainerRef?.current) {
      const calendarHeight = calendarRef?.current?.offsetHeight || 0;
      const scrollOffset = calendarHeight - 150;
      scrollContainerRef.current.scrollTo({
        top: scrollOffset ?? 100,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
      });
      document.documentElement.scrollTop = document.documentElement.scrollHeight;
      document.body.scrollTop = document.body.scrollHeight;
    }
  }, 10);
}

export function scrollToTop(scrollContainerRef?: any) {
  setTimeout(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
      });
    } else {
      window.scrollTo({
        top: 0,
      });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, 10);
}

export function scrollToTopCalender(scrollContainerRef?: any) {
  setTimeout(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    window.scrollTo({
      top: 0,
    });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 10);
}

export function getTripName(chatData: iChatData) {
  const list = chatData?.destinationList || [];
  return list.reduce((acc: string, ele: iCityDetailsResult, index: number) => {
    const city = ele?.cityName?.split(",")[0] || ele?.city_name || ele?.destination_city;
    if (index === list.length - 1) return acc + city;
    else return acc + city + ", ";
  }, "");
}

/**
 * Add itinerary version
 */

export function getItineraryVersion(chatData: iChatData[], currentItinerary: any) {
  try {
    if (!chatData || chatData?.length === 0 || !currentItinerary) return "1";
    const reverseChatData = chatData.reverse();
    const currentCity = currentItinerary?.destinationList?.[0]?.city_name;
    const lastItinerary = reverseChatData?.find(
      (ele: iChatData) => ele?.destinationList?.[0]?.city_name === currentCity
    );

    if (!lastItinerary) return "1";
    return String(Number(lastItinerary?.itinerary_version) + 1);
  } catch {
    return "1";
  }
}

export function checkIfItineraryIsValid(data: iChatData) {
  if (!data || !data.destinationList || data.destinationList.length === 0) {
    return true;
  }

  for (const destination of data.destinationList) {
    if (!destination.tripDetails || destination.tripDetails.length === 0) {
      return true;
    }

    for (const tripDetail of destination.tripDetails) {
      if (!tripDetail.itinerary_by_time_of_the_day || tripDetail.itinerary_by_time_of_the_day.length === 0) {
        return true;
      }

      for (const itinerary of tripDetail.itinerary_by_time_of_the_day) {
        if (!itinerary.description || itinerary.description.trim() === "") {
          return true;
        }
      }
    }
  }

  return false;
}

export function getItineraryPriceCityList(
  data: { city_country_code: string; city_name: string }[]
): { country: string; city: string }[] {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data
    .map(({ city_country_code, city_name }) => ({
      country: city_country_code,
      city: city_name,
    }))
    .filter(({ country, city }) => country && city); // Filter out empty values
}

export async function updateChatDataWithPrice(
  accessJWT: string,
  setSelectedChatData: any,
  setChatData: any,
  tempDestinationList: any
) {
  const pricePayload = {
    cities: getItineraryPriceCityList(tempDestinationList),
  };
  const priceResponse = await getItineraryPriceAPI(accessJWT, pricePayload);
  setChatData((prevChatData: any) => {
    if (prevChatData.length > 0) {
      let lastChatData: iChatData = {
        ...prevChatData[prevChatData.length - 1], // Copy the last element
        estimatedPrice: priceResponse?.data?.totalPrice ?? "0",
      };
      setSelectedChatData(lastChatData);
      return [
        ...prevChatData.slice(0, -1), // All elements except the last
        lastChatData,
      ];
    }
    return prevChatData; // If empty, return as is
  });
}

export function extractNumber(value: string): number {
  const numberString = value.replace(/\D/g, ""); // Remove all non-digit characters
  return numberString ? Number(numberString) : 0; // Convert to number or return 0 if empty
}
